import React from "react";
import CalendarRange from "../../../../../../../../../../../util/calendarRange/.mixins/index";

//css
import StylesCss from "./styles";
const useStyles = StylesCss();

const CalendarFilter = ({ dtInitial, setDtInitial, dtEnd, setDtEnd }) => {
    const classes = useStyles();

    const handlerChangeDateInitial = (value) => {
        setDtInitial(value);
    };

    const handlerChangeDateEnd = (value) => {
        setDtEnd(value);
    };

    return (
        <div className={classes.root}>
            <div className={classes.calendar}>
                <CalendarRange
                    dtInitial={dtInitial}
                    dtEnd={dtEnd}
                    handlerChangeDateInitial={handlerChangeDateInitial}
                    handlerChangeDateEnd={handlerChangeDateEnd}
                />
            </div>
        </div>
    );
};

export default CalendarFilter;
